<template lang="pug">
include ../mixins
+b.ls-card--space_custom.--color_white.--border_3sm-adaptive.pos--relative
  ui-preloader(
    :class="{'is-active': isLoad}"
    loader-color='loader-wrapper__bg--accent-1'
    loader-class="loader--variant_absolute"
  )
  +b.modal-close--common.BUTTON(
    tabindex="-1"
    @click="$emit('close')"
  )

  //- Крок «оферта». Поки договір не прийнято, платити не даємо — бекенд
  //- однаково поверне contractRequired.
  template(v-if="step === 'contract'")
    +b.P.ls-text.--size_2sm.--weight_semi-bold.--height_md {{ _("Ознайомлений/на та приймаю (акцепт) пропозицію укласти Публічний договір приєднання (оферта) та погоджуюся з Правилами для студентів.") }}
    +b.ma.--top_sm.txt-center(v-if="contractLink")
      +b.A.ls-text.--size_2sm.--weight_semi-bold.--height_md.--variant_center.--color_accent-1(
        :href="contractLink"
        target="_blank"
      ) {{ _("Ознайомитися з договором") }}
    +b.ma.--top_sm.txt-center(v-if="nonFieldErrors[0]")
      +b.P.control-hint.--variant_1.--appearance_center {{ nonFieldErrors[0] }}
    +b.ma.--top_sm
      +b.g-row.--align_center
        +b.g-cell.g-cols--12.txt-center
          +b.form.ma--bottom_sm
            +b.LABEL.d-control-checkbox.--variant_flex-center
              +e.INPUT.element(
                type='checkbox'
                v-model='isAccepted'
                name='isAccepted'
              )
              +e.label
              +e.SPAN.content {{ _('Підтверджую, що прочитав і згоден') }}
        +b.g-cell.g-cols--12.txt-center
          +b.BUTTON.ls-button.--variant_accent-1(
            @click.prevent="acceptContract"
            :disabled="!isAccepted || isLoad"
          ) {{ _('Погоджуюсь та приймаю') }}

  //- Крок «попередження»: клієнт щойно вже щось оплачував (ТЗ п.5).
  //- Не забороняємо, а перепитуємо.
  template(v-else-if="step === 'confirmation'")
    +b.P.ls-text.--size_2sm.--height_md {{ warningMessage }}
    +b.ma.--top_sm(v-if="nonFieldErrors[0]")
      +b.P.control-hint.--variant_1.--appearance_center {{ nonFieldErrors[0] }}
    +b.ma.--top_md
      +b.g-row.--align_center
        +b.g-cell.g-cols--6
          +b.i-link.--color_accent-1(
            @click.prevent="$emit('close')"
          ) {{ _('Відмінити') }}
        +b.g-cell.g-cols--6
          +b.BUTTON.ls-button.--appearance_coral(
            @click.prevent="pay(true)"
            :disabled="isLoad"
          ) {{ _('Все одно сплатити') }}

  //- Крок «сума»: звичайне підтвердження.
  template(v-else)
    +b.P.ls-text.--size_3sm.--weight_semi-bold.--height_md.--variant_center {{ _("Ви впевнені, що хочете сплатити?") }}
    +b.ma.--top_sm
      +b.P.ls-text.--size_2sm.--weight_semi-bold.--height_md.--variant_center.--color_accent-1 {{ _("Сума до сплати:") }} {{ option.payOption }}
    +b.ma.--top_sm(v-if="option.finishDate")
      +b.P.ls-text.--size_2xs.--height_md.--variant_center {{ _("За період до") }} {{ option.finishDate }}
    +b.ma.--top_sm(v-if="nonFieldErrors[0]")
      +b.P.control-hint.--variant_1.--appearance_center {{ nonFieldErrors[0] }}
    +b.ma.--top_md
      +b.g-row.--align_center
        +b.g-cell.g-cols--6
          +b.i-link.--color_accent-1(
            @click.prevent="$emit('close')"
          ) {{ _('Відмінити') }}
        +b.g-cell.g-cols--6
          //- `disabled` на час запиту: подвійний клік по цій кнопці — найкоротший
          //- шлях до двох платіжних сторінок на ту саму суму.
          +b.BUTTON.ls-button.--variant_accent-1(
            @click.prevent="pay(false)"
            :disabled="isLoad"
          ) {{ _('Сплатити') }}
</template>

<script>
import { paymentVariantPayResource } from '@/js/services/payment-period.service'
import { contractAcceptResource } from '@/js/services/document.service'
import {
  defaultValidatorErrorsParser,
  getCommonParsedErrors,
} from '@/js/mixins/form.mixin.js'

export default {
  name: 'variant-payment-modal',

  props: {
    objectItem: {},
  },

  data() {
    return {
      // 'amount' -> 'contract' | 'confirmation' -> редирект у PayHub
      step: 'amount',
      isLoad: false,
      isAccepted: false,
      nonFieldErrors: [],
      contractLink: '',
      warningMessage: '',
    }
  },

  computed: {
    option() {
      return this.objectItem?.option || {}
    },

    orderId() {
      return this.objectItem?.order
    },

    groupId() {
      return this.objectItem?.groupId
    },
  },

  mounted() {
    this.contractLink = this.objectItem?.contractLink || ''
    // Якщо про непідписаний договір відомо заздалегідь — не змушуємо клієнта
    // тицяти «Сплатити», щоб про це дізнатись.
    if (false === this.objectItem?.hasContract) {
      this.step = 'contract'
    }
  },

  methods: {
    pay(confirmed) {
      this.isLoad = true
      this.nonFieldErrors = []

      const formdata = {
        order: this.orderId,
        payToken: this.option.payToken,
        confirmed: !!confirmed,
      }

      return paymentVariantPayResource.execute({}, formdata).then(res => {
        const item = res?.data?.item || {}

        if (item.contractRequired) {
          this.contractLink = item.contractLink || this.contractLink
          this.step = 'contract'
          return
        }

        if (item.confirmationRequired) {
          this.warningMessage = item.message
          this.step = 'confirmation'
          return
        }

        if (item.payUrl) {
          window.location = item.payUrl
        }
      }).catch(async e => {
        const errors = await getCommonParsedErrors(e)

        this.updateValidator(errors)
      }).finally(() => {
        this.isLoad = false
      })
    },

    acceptContract() {
      this.isLoad = true
      this.nonFieldErrors = []

      // Акцепт закриває всі групи родини одразу, тож `groupId` тут лише
      // гарантує, що поточний курс точно потрапить у набір.
      return contractAcceptResource.execute({}, {
        group_id: this.groupId,
      }).then(() => {
        this.$root.$emit('contractAccepted')
        this.step = 'amount'
        // Договір щойно прийнято — одразу продовжуємо оплату, щоб клієнт не
        // тицяв «Сплатити» вдруге.
        return this.pay(false)
      }).catch(async e => {
        const errors = await getCommonParsedErrors(e)

        this.updateValidator(errors)
      }).finally(() => {
        this.isLoad = false
      })
    },

    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)

      this.nonFieldErrors = parsed.nonFieldErrors
    },
  },
}
</script>
